// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfigureBidGroupsStepQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
  productOfferingIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ConfigureBidGroupsStepQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, potentialBidPlanOptions: Array<{ __typename?: 'PotentialBidPlanOption', globalOption: { __typename?: 'GlobalOption', id: string, name: string }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } }> }> }, potentialBidPlanDimensions: Array<{ __typename?: 'PotentialBidPlanDimensionResult', id: string, type: { __typename?: 'GlobalOptionType', order: number, id: string, name: string }, options: Array<{ __typename?: 'GlobalOption', id: string, name: string }> }> };


export const ConfigureBidGroupsStepDocument = gql`
    query ConfigureBidGroupsStep($bidPackageId: ID!, $productOfferingIds: [ID!]!) {
  bidPackage(id: $bidPackageId) {
    id
    productOfferings {
      ...Named
    }
    potentialBidPlanOptions {
      globalOption {
        ...Named
      }
      readyPlanOptions {
        id
        readyPlan {
          ...Named
        }
      }
    }
  }
  potentialBidPlanDimensions(productOfferingIds: $productOfferingIds) {
    id
    type {
      ...Named
      order
    }
    options {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useConfigureBidGroupsStepQuery__
 *
 * To run a query within a React component, call `useConfigureBidGroupsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigureBidGroupsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigureBidGroupsStepQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *      productOfferingIds: // value for 'productOfferingIds'
 *   },
 * });
 */
export function useConfigureBidGroupsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables> & ({ variables: ConfigureBidGroupsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>(ConfigureBidGroupsStepDocument, options);
      }
export function useConfigureBidGroupsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>(ConfigureBidGroupsStepDocument, options);
        }
// @ts-ignore
export function useConfigureBidGroupsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>;
export function useConfigureBidGroupsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigureBidGroupsStepQuery | undefined, ConfigureBidGroupsStepQueryVariables>;
export function useConfigureBidGroupsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>(ConfigureBidGroupsStepDocument, options);
        }
export type ConfigureBidGroupsStepQueryHookResult = ReturnType<typeof useConfigureBidGroupsStepQuery>;
export type ConfigureBidGroupsStepLazyQueryHookResult = ReturnType<typeof useConfigureBidGroupsStepLazyQuery>;
export type ConfigureBidGroupsStepSuspenseQueryHookResult = ReturnType<typeof useConfigureBidGroupsStepSuspenseQuery>;
export type ConfigureBidGroupsStepQueryResult = Apollo.QueryResult<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>;